export const basicauth={
    username: "info@seobix@bumppy@goseo",
    password: "goseo@bumppy@seobix@info",
};